﻿import { Size } from "./size";

/**
 * 2次元の点を表ます。
 *
 * @example
 *
 * ```typescript
 *
 * let pointA = new Point(10, 20);
 * let pointB = new Point(0, 10);
 * let pointC = pointB.offset({x:10, y:-10})
 *
 * console.assert(pointA.equals(pointC)); // true
 * ```
 */

export class Point {
  static EPS = 0.01;
  /** x座標 */
  public /*readonly*/ x: number;
  /** y座標 */
  public /*readonly*/ y: number;

  constructor(p: Point);
  constructor(x: number, y: number);
  constructor(arg0: Point | number, arg1?: number) {
    if (arg0 instanceof Point) {
      this.x = arg0.x;
      this.y = arg0.y;
    } else {
      this.x = arg0 as number;
      this.y = arg1 as number;
    }
  }

  /**
   * 指定された量だけ　この点 を移動します。
   * @param that 移動量
   */
  public offset(that: { x: number; y: number }): Point {
    return new Point(this.x + that.x, this.y + that.y);
  }

  /**
   * 指定された量だけ　この点 を移動します。
   * 移動は　x座標 方向に行われます。
   * @param n x座標方向の値
   *
   * @example
   * ```typescript
   *
   * let p = new Point(10, 20);
   * console.log(p.offsetX(-10));
   * // Point[0,20]
   * ```
   */
  public offsetX(n: number): Point {
    return new Point(this.x + n, this.y);
  }

  /**
   * 指定された量だけ　この点 を移動します。
   * 移動は　y座標 方向に行われます。
   * @param n y座標方向の値
   */
  public offsetY(n: number): Point {
    return new Point(this.x, this.y + n);
  }

  /**
   * 指定された点と x座標、y座標 が一致するかテストします。
   * @param that
   */
  public equals(that: Point): boolean {
    //return this.x === that.x && this.y === that.y;
    return (
      Math.abs(this.x - that.x) < Point.EPS &&
      Math.abs(this.y - that.y) < Point.EPS
    );
  }

  public round(): void /*Rectangle*/ {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
  }

  /**
   * この点を文字列に変換します。
   */
  public toString(): string {
    return `Point:[${this.x},${this.y}]`;
  }

  public distance(that: Point): number {
    let cx = Math.abs(this.x - that.x);
    let cy = Math.abs(this.y - that.y);
    let size = Math.sqrt(cx ** 2 + cy ** 2);
    return size;
  }
}
